import { render, staticRenderFns } from "./CalendarioToolbar.vue?vue&type=template&id=4f841afb&"
import script from "./CalendarioToolbar.vue?vue&type=script&lang=js&"
export * from "./CalendarioToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/calendario/CalendarioToolbar.vue
// module id = 1098
// module chunks = 28